"use client";

import type {LinkProps as HeroUiLinkProps} from "@heroui/link";
import type {ComponentProps} from "react";

import {forwardRef} from "react";
import {useLink} from "@heroui/link";
import {linkAnchorClasses} from "@heroui/react";
import {LinkIcon} from "@heroui/shared-icons";

import {Link as i18nLink} from "@/i18n/navigation";

export type LinkProps = ComponentProps<typeof i18nLink> & Omit<HeroUiLinkProps, "href">;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const {href, ...linkProps} = props;

  const {
    Component,
    children,
    showAnchorIcon,
    anchorIcon = <LinkIcon className={linkAnchorClasses} />,
    getLinkProps,
  } = useLink({
    ...linkProps,
    as: i18nLink,
    href: "",
    ref,
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars, unused-imports/no-unused-vars
  const {href: _dest, ...restProps} = getLinkProps();

  return (
    <Component {...restProps} href={href}>
      <>
        {children}
        {showAnchorIcon && anchorIcon}
      </>
    </Component>
  );
});

Link.displayName = "OVISION.Link";
